import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { AdminUserService } from '@/modules/user/services/admin-user.service'
import { UpdateBankAccountRequestModel } from '@/modules/bank-account/models/bank-account-request.model'
import { BankAccountResourceModel } from '@/modules/bank-account/models/bank-account-resource.model'

@vservice()
export class AdminUpdateUserBankAccountUse implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminUserService
  ) {
  }

  private loadingState: boolean = false

  private successState: boolean = false

  get isLoading() {
    return this.loadingState
  }

  get isSuccess() {
    return this.successState
  }

  execute(userId: number, data: BankAccountResourceModel) {
    return this.service.updateBankInfo(userId, this.requestData(data))
      .onStart(() => {
        this.loadingState = true
        this.successState = false
      })
      .onFinish(() => {
        this.loadingState = false
      })
      .onSuccess(() => {
        this.successState = true
      })
  }

  requestData(data: BankAccountResourceModel): UpdateBankAccountRequestModel {
    return {
      account_type: data.account_type,
      sheba: data.sheba,
      card_number: data.card_number,
      account_owner_name: data.account_owner_name,
      bank_name: data.bank_name,
      withdraw_period: data.withdraw_period,
      withdraw_period_day: data.withdraw_period_day,
      national_identity_image: data.national_identity_image
    }
  }
}
